import { ServiceCall } from "support/network/ServiceCallAction"
import { prepareHeadersFromState } from "../../HeadersUtils"
import {ADD_CHALLENGEDRAFT_ID_IMAGE_FAILURE, ADD_CHALLENGEDRAFT_ID_IMAGE_STARTED, ADD_CHALLENGEDRAFT_ID_IMAGE_SUCCESS, DELETE_CHALLENGEDRAFT_ID_IMAGE_FAILURE, DELETE_CHALLENGEDRAFT_ID_IMAGE_STARTED, DELETE_CHALLENGEDRAFT_ID_IMAGE_SUCCESS, GET_CHALLENGEINTOINNOVATE_DRAFT_FAILURE, GET_CHALLENGEINTOINNOVATE_DRAFT_STARTED, GET_CHALLENGEINTOINNOVATE_DRAFT_SUCCESS, GET_INNOVATE_CHALLENGE_ACTIVE_TYPES_FAILURE, GET_INNOVATE_CHALLENGE_ACTIVE_TYPES_STARTED, GET_INNOVATE_CHALLENGE_ACTIVE_TYPES_SUCCESS, GET_INNOVATE_CHALLENGE_ALL_LIST_FAILURE, GET_INNOVATE_CHALLENGE_ALL_LIST_STARTED, GET_INNOVATE_CHALLENGE_ALL_LIST_SUCCESS, GET_INNOVATE_CHALLENGE_FAILURE, GET_INNOVATE_CHALLENGE_FILTER_LIST_FAILURE, GET_INNOVATE_CHALLENGE_FILTER_LIST_STARTED, GET_INNOVATE_CHALLENGE_FILTER_LIST_SUCCESS, GET_INNOVATE_CHALLENGE_LIST_REMOVE_EVALUATOR_FAILURE, GET_INNOVATE_CHALLENGE_LIST_REMOVE_EVALUATOR_STARTED, GET_INNOVATE_CHALLENGE_LIST_REMOVE_EVALUATOR_SUCCESS, GET_INNOVATE_CHALLENGE_STARTED, GET_INNOVATE_CHALLENGE_SUCCESS, GET_INNOVATE_CHALLENGE_TAGGED_IDEA_LIST_REMOVE_EVALUATOR_FAILURE, GET_INNOVATE_CHALLENGE_TAGGED_IDEA_LIST_REMOVE_EVALUATOR_STARTED, GET_INNOVATE_CHALLENGE_TAGGED_IDEA_LIST_REMOVE_EVALUATOR_SUCCESS, POST_CHALLENGE_INNOVATE_REMOVE_EVALUTOR_FAILURE, POST_CHALLENGE_INNOVATE_REMOVE_EVALUTOR_STARTED, POST_CHALLENGE_INNOVATE_REMOVE_EVALUTOR_SUCCESS, POST_INNOVATE_CHALLENGE_CREATE_FAILURE, POST_INNOVATE_CHALLENGE_CREATE_STARTED, POST_INNOVATE_CHALLENGE_CREATE_SUCCESS, POST_INNOVATE_CHALLENGE_DRAFT_FAILURE, POST_INNOVATE_CHALLENGE_DRAFT_STARTED, POST_INNOVATE_CHALLENGE_DRAFT_SUCCESS, POST_INNOVATE_SPECIFIC_IDEA_LIST_FROM_CHALLENGE_REMOVE_EVALUATOR_FAILURE, POST_INNOVATE_SPECIFIC_IDEA_LIST_FROM_CHALLENGE_REMOVE_EVALUATOR_STARTED, POST_INNOVATE_SPECIFIC_IDEA_LIST_FROM_CHALLENGE_REMOVE_EVALUATOR_SUCCESS, PUT_INNOVATE_CHALLENGE_EDIT_FAILURE, PUT_INNOVATE_CHALLENGE_EDIT_STARTED, PUT_INNOVATE_CHALLENGE_EDIT_SUCCESS } from "actions/sync/innovate/challenge/Constants"
import { transformTypeServiceResponseDataWithState } from "services/types/ResponseUtils"
import { transformChallengeDraft, transformDeleteImageResponse, transformImageServiceResponse } from "services/challenge_steps/ResponseUtils"
import { setImageContent } from "services/challenge_steps/RequestUtils"
import { FIRST_LIMIT_CONSTANT, LIMIT_CONSTANT } from 'common_constants/Ideas'

export const challenge_List_Filter_URL = 'api/v1/innovate/challenge/challengesList/filter'
export const listChallengeAllURL = 'api/v1/innovate/challenge/challengesList'
export const createInnovateChallengeURL = 'api/v1/innovate/challenge/launchInnovateChallenge'
export const EditInnovateChallengeURL = 'api/v1/innovate/challenge/editInnovateChallenge'
export const DraftInnovateChallengeURL = 'api/v1/innovate/challenge/draftInnovateChallenge'
export const GET_ACTIVE_TYPES_URL = '/s/domain/type/active'
// const GET_DRAFT_CHALLENGE_URL = '/s/v1.0/challenge/draft'
const GET_DRAFT_CHALLENGE_URL = 'api/v1/innovate/challenge/draft'
const getInnovateChallengeURL = 'api/v1/challenge/innovate'
const getInnovateChallengeForRemoveEvaluatoURL = '/api/v1/innovate/challenge/evaluationTask/admin/challengesList'
const getInnovateIdeaFromChallengeForRemoveEvaluatoURL = '/api/v1/innovate/challenge/evaluationTask/admin/getIdeaForChallenge/##challengeKey##/##userEmail##'
// const getInnovateChallengeURL = 'api/v1/challenge'
// const getInnovateChallengeURL = '/s/v1.0/challenge/##challengeId##'

const REMOVE_EVALUATOR_CHALLENGE = '/api/v1/innovate/challenge/evaluationTask/admin/updateEvaluationTask' 
const REMOVE_EVALUATOR_IDEA_SPECIFIC_EVALUATION = '/api/v1/innovate/challenge/evaluationTask/admin/ideaSpecificEvaluationTask' 



const ADD_IMAGE_URL = '/s/v1.0/challenge/image'
const DELETE_IMAGE_URL = '/s/v1.0/challenge'

function convertDateToMilliseconds(dateString) {
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) {
    throw new Error("Invalid date format");
  }
  return date.getTime();
}


function setInnovateChallengeDraftEndpoint(draftChallengeData,isAdminEmail) {

  const {
    id='',
    title = '',
    summary = '',
    category = '',
    startingDate = null,
    closingDate = null,
    termsAndConditions = '',
    templateScorecard = null,
    templateIdea = null,
    challengeOwner = '',
    communities = [],
    groupIds = [],
    images=[],
    isHackathonChallenge=false,
    organizerEmails=[]
  } = draftChallengeData;

  const startDate = convertDateToMilliseconds(startingDate);
  const endsDate = convertDateToMilliseconds(closingDate);
  const passImageName = images?.name || '';
  const communit = Array.isArray(communities)
    ? communities.map(item => item.value)
    : [];

  const templateIdeaID = templateIdea?.id || '';
  const templateScorecardId = templateScorecard?.id || '';

  return `${encodeURIComponent('id')}=${encodeURIComponent(id)}&${encodeURIComponent('title')}=${encodeURIComponent(title)}&${encodeURIComponent('summary')}=${encodeURIComponent(summary)}&${encodeURIComponent('category')}=${encodeURIComponent(category)}&${encodeURIComponent('starts')}=${encodeURIComponent(startDate)}&${encodeURIComponent('ends')}=${encodeURIComponent(endsDate)}&${encodeURIComponent('termAndContdions')}=${encodeURIComponent(termsAndConditions)}&${encodeURIComponent('scoreCardTemplateId')}=${encodeURIComponent(templateScorecardId)}&${encodeURIComponent('ideaTemplateId')}=${encodeURIComponent(templateIdeaID)}&${encodeURIComponent('challengeOwner')}=${encodeURIComponent(isAdminEmail)}&${encodeURIComponent('groupIds')}=${encodeURIComponent(communit)}&${encodeURIComponent('images')}=${encodeURIComponent(passImageName)}&${encodeURIComponent('isHackathonChallenge')}=${encodeURIComponent(isHackathonChallenge)}&${encodeURIComponent('organizerEmails')}=${encodeURIComponent(organizerEmails)}`;
}


function setInnovateChallengeCreateEndpoint(createChallengeData,isAdminEmail) {

  const {
    id = '',
    title = '',
    summary = '',
    category = '',
    startingDate = null,
    closingDate = null,
    termsAndConditions = '',
    templateScorecard = null,
    templateIdea = null,
    challengeOwner = '',
    communities = [],
    groupIds = [],
    images=[],
    isHackathonChallenge=false,
    organizerEmails=[]
  } = createChallengeData;

  const startDate = convertDateToMilliseconds(startingDate);
  const endsDate = convertDateToMilliseconds(closingDate);
  const passImageName = images?.name || '';
  const communit = Array.isArray(communities)
    ? communities.map(item => item.value)
    : [];
  const templateIdeaID = templateIdea?.id || '';
  const templateScorecardId = templateScorecard?.id || '';
  return `${encodeURIComponent('id')}=${encodeURIComponent(id)}&${encodeURIComponent('title')}=${encodeURIComponent(title)}&${encodeURIComponent('summary')}=${encodeURIComponent(summary)}&${encodeURIComponent('category')}=${encodeURIComponent(category)}&${encodeURIComponent('starts')}=${encodeURIComponent(startDate)}&${encodeURIComponent('ends')}=${encodeURIComponent(endsDate)}&${encodeURIComponent('termAndContdions')}=${encodeURIComponent(termsAndConditions)}&${encodeURIComponent('scoreCardTemplateId')}=${encodeURIComponent(templateScorecardId)}&${encodeURIComponent('ideaTemplateId')}=${encodeURIComponent(templateIdeaID)}&${encodeURIComponent('challengeOwner')}=${encodeURIComponent(challengeOwner)}&${encodeURIComponent('groupIds')}=${encodeURIComponent(communit)}&${encodeURIComponent('images')}=${encodeURIComponent(passImageName)}&${encodeURIComponent('isHackathonChallenge')}=${encodeURIComponent(isHackathonChallenge)}&${encodeURIComponent('organizerEmails')}=${encodeURIComponent(organizerEmails)}`;
}

const setImageAddDraftIDContent = (IdForImage,image, state, type) => {
  return `${encodeURIComponent('id')}=${encodeURIComponent(IdForImage)}&${encodeURIComponent('image')}=${encodeURIComponent(image)}&${encodeURIComponent(
    'mode',
  )}=${encodeURIComponent(type)}`
}

 const setDeleteImageContent = (IdForImage,imageName, state, type) => {
 const  imageNameExt = imageName?.name
  return `${IdForImage}/image/${encodeURIComponent(type)}/${encodeURIComponent(
    imageNameExt,
  )}`
}

// const setContentRemoveEvaluator = (removeEvaluatorParams) => {
//   console.log("removeEvaluatorParams,", removeEvaluatorParams)
//   const { challengeKey, userEmail} = removeEvaluatorParams
//   return `${encodeURIComponent('challengeKey')}=${encodeURIComponent(challengeKey)}&${encodeURIComponent('userEmail')}=${encodeURIComponent(userEmail)}`
// }
const setContentRemoveEvaluator = (removeEvaluatorParams) => {
  const {
    challengeKeyStr,
    challengeKeyList = [],
    userEmail
  } = removeEvaluatorParams;

  const params = new URLSearchParams();
  params.append("userEmail", userEmail);

  // ✅ ChallengeKeys → comma-separated values
  const ChallengeKeysValue = challengeKeyStr.map(item => item.value).join(",");
  params.append("challengeKeyStr", ChallengeKeysValue);

  // ✅ ChallengeKeysList → repeated keys (List<String>)
  challengeKeyList.forEach(item => {
    params.append("challengeKeyList", item.value);
  });

  return params;

}



const setContentIdeaListRemoveEvaluator = (data) => {
  const {
    challengeKey,
    ideaKeys = [],
    ideaKeysList = [],
    userEmail
  } = data;

  const params = new URLSearchParams();

  params.append("challengeKey", challengeKey);
  params.append("userEmail", userEmail);

  // ✅ ideaKeys → comma-separated values
  const ideaKeysValue = ideaKeys.map(item => item.value).join(",");
  params.append("ideaKeys", ideaKeysValue);

  // ✅ ideaKeysList → repeated keys (List<String>)
  ideaKeysList.forEach(item => {
    params.append("ideaKeysList", item.value);
  });

  return params;
};




export function deleteInnovateChallengeImage(
  IdForImage,
  imageName,
  onFailure,
  type='innovate'
) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = DELETE_CHALLENGEDRAFT_ID_IMAGE_STARTED
  apiCall.successReqType = DELETE_CHALLENGEDRAFT_ID_IMAGE_SUCCESS
  apiCall.failureReqType = DELETE_CHALLENGEDRAFT_ID_IMAGE_FAILURE
  apiCall.setEndpointFromState = state =>
    `${DELETE_IMAGE_URL}/${setDeleteImageContent(IdForImage,imageName, state, type)}` 
  apiCall.method = 'DELETE'
  apiCall.onFailure = onFailure
  apiCall.transformResponseDataWithState = transformDeleteImageResponse
  apiCall.auth = true
  return apiCall.getAction()
}


export function postInnovateChallengeImage( 
  IdForImage,
  image,
  onSuccess,
  onFailure,
  type='innovate') {
    const base64img = image?.src
  const apiCall = new ServiceCall()
  apiCall.startedReqType = ADD_CHALLENGEDRAFT_ID_IMAGE_STARTED
  apiCall.successReqType = ADD_CHALLENGEDRAFT_ID_IMAGE_SUCCESS
  apiCall.failureReqType = ADD_CHALLENGEDRAFT_ID_IMAGE_FAILURE
  apiCall.setEndpointFromState = () => ADD_IMAGE_URL
  apiCall.method = 'POST'
  apiCall.setBodyFromState = state => setImageAddDraftIDContent(IdForImage,base64img, state, type)
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.transformResponseDataWithState = transformImageServiceResponse 
  apiCall.auth = true
  return apiCall.getAction()
}


export function getInnovateChallengeActiveTypes() {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_INNOVATE_CHALLENGE_ACTIVE_TYPES_STARTED
  apiCall.successReqType = GET_INNOVATE_CHALLENGE_ACTIVE_TYPES_SUCCESS
  apiCall.failureReqType = GET_INNOVATE_CHALLENGE_ACTIVE_TYPES_FAILURE
  apiCall.setEndpointFromState = () => GET_ACTIVE_TYPES_URL
  apiCall.method = 'GET'
  apiCall.getHeadersFromState = prepareHeadersFromState
  apiCall.transformResponseDataWithState = transformTypeServiceResponseDataWithState
  apiCall.auth = true
  return apiCall.getAction()
}



export function getInnovateChallengeAllList() {
    const apiCall = new ServiceCall()
    apiCall.startedReqType = GET_INNOVATE_CHALLENGE_ALL_LIST_STARTED
    apiCall.successReqType = GET_INNOVATE_CHALLENGE_ALL_LIST_SUCCESS
    apiCall.failureReqType = GET_INNOVATE_CHALLENGE_ALL_LIST_FAILURE
    apiCall.setEndpointFromState = () =>
      `${listChallengeAllURL}`
    apiCall.method = 'GET'
    apiCall.getHeadersFromState = prepareHeadersFromState
    // apiCall.transformResponseDataWithState = transformGetChallengeByIdService
    apiCall.auth = true
    return apiCall.getAction()
}

export function postInnovateChallengeCreate(createChallengeData,isAdminEmail,onSuccess,onFailure) {
  // const {} = CreateChallengeData 
  const apiCall = new ServiceCall()
  apiCall.startedReqType = POST_INNOVATE_CHALLENGE_CREATE_STARTED
  apiCall.successReqType = POST_INNOVATE_CHALLENGE_CREATE_SUCCESS
  apiCall.failureReqType = POST_INNOVATE_CHALLENGE_CREATE_FAILURE
  apiCall.setEndpointFromState = () => createInnovateChallengeURL
  apiCall.method = 'POST'
  apiCall.setBodyFromState= ()=> setInnovateChallengeCreateEndpoint(createChallengeData,isAdminEmail)
  apiCall.getHeadersFromState = prepareHeadersFromState
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  // apiCall.transformResponseDataWithState = transformGetChallengeByIdService
  apiCall.auth = true
  return apiCall.getAction()
}


export function getInnovateChallengeFilterList(challengeFilterParams) {

  //console.log("challengeFilterParams", challengeFilterParams)
  const {challengeStatus = 'ACTIVE',enableIsHackathon=false,limit = FIRST_LIMIT_CONSTANT, offset=0} = challengeFilterParams

  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_INNOVATE_CHALLENGE_FILTER_LIST_STARTED
  apiCall.successReqType = GET_INNOVATE_CHALLENGE_FILTER_LIST_SUCCESS
  apiCall.failureReqType = GET_INNOVATE_CHALLENGE_FILTER_LIST_FAILURE
  // apiCall.setEndpointFromState = () =>`${challenge_List_Filter_URL}?status=${challengeFilterParams}`
  apiCall.setEndpointFromState = () =>`${challenge_List_Filter_URL}?offset=${offset}&isHackathon=${enableIsHackathon}&status=${challengeStatus}&limit=${limit}`

  apiCall.method = 'GET'
  apiCall.getHeadersFromState = prepareHeadersFromState
  // apiCall.transformResponseDataWithState = transformGetChallengeByIdService
  apiCall.auth = true
  return apiCall.getAction()
}

//Before creating a challenge, we need an ID. The ID is generated in the response when a draft API call is made.
 
export function getChallengeIntoInnovateDraft(onSuccess) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_CHALLENGEINTOINNOVATE_DRAFT_STARTED
  apiCall.successReqType = GET_CHALLENGEINTOINNOVATE_DRAFT_SUCCESS
  apiCall.failureReqType = GET_CHALLENGEINTOINNOVATE_DRAFT_FAILURE
  apiCall.setEndpointFromState = () => GET_DRAFT_CHALLENGE_URL
  apiCall.method = 'GET'
  apiCall.auth = true
  apiCall.transformResponseDataWithState = transformChallengeDraft
  apiCall.onSuccess = onSuccess
  return apiCall.getAction()
}

export function postInnovateChallengeDraft(draftChallengeData,isAdminEmail,onSuccess,onFailure) {
  // const {} = draftChallengeData 
  const apiCall = new ServiceCall()
  apiCall.startedReqType = POST_INNOVATE_CHALLENGE_DRAFT_STARTED
  apiCall.successReqType = POST_INNOVATE_CHALLENGE_DRAFT_SUCCESS
  apiCall.failureReqType = POST_INNOVATE_CHALLENGE_DRAFT_FAILURE
  apiCall.setEndpointFromState = () => DraftInnovateChallengeURL
  apiCall.method = 'POST'
  apiCall.setBodyFromState= ()=> setInnovateChallengeDraftEndpoint(draftChallengeData,isAdminEmail)
  apiCall.getHeadersFromState = prepareHeadersFromState
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  // apiCall.transformResponseDataWithState = transformGetChallengeByIdService
  apiCall.auth = true
  return apiCall.getAction()
}


export function putInnovateChallengeEdit(EditInnovateChallengeData,onSuccess,onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = PUT_INNOVATE_CHALLENGE_EDIT_STARTED
  apiCall.successReqType = PUT_INNOVATE_CHALLENGE_EDIT_SUCCESS
  apiCall.failureReqType = PUT_INNOVATE_CHALLENGE_EDIT_FAILURE
  apiCall.setEndpointFromState = () => EditInnovateChallengeURL
  apiCall.method = 'PUT'
  apiCall.setBodyFromState= ()=>  setInnovateChallengeCreateEndpoint(EditInnovateChallengeData)
  apiCall.getHeadersFromState = prepareHeadersFromState
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.auth = true
  return apiCall.getAction()
}



export function getInnovateChallenge(id, onFailure) {

  const geturl = `${getInnovateChallengeURL}/${id}`

  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_INNOVATE_CHALLENGE_STARTED
  apiCall.successReqType = GET_INNOVATE_CHALLENGE_SUCCESS
  apiCall.failureReqType = GET_INNOVATE_CHALLENGE_FAILURE
  apiCall.setEndpointFromState = () => geturl
  apiCall.method = 'GET'
  apiCall.auth = true
  // apiCall.transformResponseDataWithState = transformChallengeDraft
  apiCall.onFailure = onFailure
  return apiCall.getAction()
}



export function getInnovateChallengeListForRemoveEvaluator() {

  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_INNOVATE_CHALLENGE_LIST_REMOVE_EVALUATOR_STARTED
  apiCall.successReqType = GET_INNOVATE_CHALLENGE_LIST_REMOVE_EVALUATOR_SUCCESS
  apiCall.failureReqType = GET_INNOVATE_CHALLENGE_LIST_REMOVE_EVALUATOR_FAILURE
  apiCall.setEndpointFromState = () =>  getInnovateChallengeForRemoveEvaluatoURL
  apiCall.method = 'GET'
  apiCall.auth = true
  return apiCall.getAction()
}
export function getInnovateIdeaListFromChallengeForRemoveEvaluator(TaggedIdeaParams) {
  console.log("TaggedIdeaParams", TaggedIdeaParams)
  const {challengeKey, userEmail} = TaggedIdeaParams
  const GetIdeaListFromChallengeKeyURL = getInnovateIdeaFromChallengeForRemoveEvaluatoURL.replace('##challengeKey##', challengeKey).replace('##userEmail##', userEmail)
  const apiCall = new ServiceCall()
  apiCall.startedReqType = GET_INNOVATE_CHALLENGE_TAGGED_IDEA_LIST_REMOVE_EVALUATOR_STARTED
  apiCall.successReqType = GET_INNOVATE_CHALLENGE_TAGGED_IDEA_LIST_REMOVE_EVALUATOR_SUCCESS
  apiCall.failureReqType = GET_INNOVATE_CHALLENGE_TAGGED_IDEA_LIST_REMOVE_EVALUATOR_FAILURE
  // apiCall.setEndpointFromState = () =>  getInnovateIdeaFromChallengeForRemoveEvaluatoURL
  apiCall.setEndpointFromState = () => GetIdeaListFromChallengeKeyURL
  apiCall.method = 'GET'
  apiCall.auth = true
  return apiCall.getAction()
}

export function postInnovateSpecificIdeaListFromChallengeRemoveEvaluator(removeEvaluatorParamsByPost,onSuccess,onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = POST_INNOVATE_SPECIFIC_IDEA_LIST_FROM_CHALLENGE_REMOVE_EVALUATOR_STARTED
  apiCall.successReqType = POST_INNOVATE_SPECIFIC_IDEA_LIST_FROM_CHALLENGE_REMOVE_EVALUATOR_SUCCESS
  apiCall.failureReqType = POST_INNOVATE_SPECIFIC_IDEA_LIST_FROM_CHALLENGE_REMOVE_EVALUATOR_FAILURE
  apiCall.setEndpointFromState = () => REMOVE_EVALUATOR_IDEA_SPECIFIC_EVALUATION
  apiCall.method = 'POST'
  apiCall.setBodyFromState= ()=> setContentIdeaListRemoveEvaluator(removeEvaluatorParamsByPost)
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.auth = true
  return apiCall.getAction()
}

export function postInnovateChallengeRemoveEvaluator(removeEvaluatorParams,onSuccess,onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = POST_CHALLENGE_INNOVATE_REMOVE_EVALUTOR_STARTED
  apiCall.successReqType = POST_CHALLENGE_INNOVATE_REMOVE_EVALUTOR_SUCCESS
  apiCall.failureReqType = POST_CHALLENGE_INNOVATE_REMOVE_EVALUTOR_FAILURE
  apiCall.setEndpointFromState = () => REMOVE_EVALUATOR_CHALLENGE
  apiCall.method = 'POST'
  apiCall.setBodyFromState= ()=> setContentRemoveEvaluator(removeEvaluatorParams)
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.auth = true
  return apiCall.getAction()
}